import { render, staticRenderFns } from "./SubjectFilter.vue?vue&type=template&id=bfa481f2&scoped=true"
import script from "./SubjectFilter.vue?vue&type=script&lang=js"
export * from "./SubjectFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa481f2",
  null
  
)

export default component.exports